import type { ActionContext } from 'js/lib/ActionContext';

import thirdPartyAuth from 'bundles/third-party-auth/lib';
import type { SSO_TYPE } from 'bundles/third-party-auth/lib';

export type DelinkPayload = {
  accountType: SSO_TYPE;
  currentAccountType?: string;
  password?: string;
  onSuccess?: () => void;
};

export const getLinkedAccounts = function (actionContext: ActionContext) {
  actionContext.dispatch('LOADING', { action: 'getLinkedAccounts' });
  return thirdPartyAuth
    .getLinkedAccounts()
    .then((linkedAccounts) => {
      actionContext.dispatch('ACCOUNT_LINK_GET_ACCOUNT_SUCCESS', {
        linkedAccounts,
      });
    })
    .catch((error) => {
      actionContext.dispatch('ERROR', error);
    });
};

export const link = function (actionContext: $TSFixMe, payload: $TSFixMe) {
  const { accountType, ...data } = payload;
  actionContext.dispatch('CURRENT_ACCOUNT_SET', { currentAccount: accountType });
  actionContext.dispatch('LOADING', Object.assign({ action: 'link' }, payload));
  return thirdPartyAuth
    .link(accountType, data)
    .then((result) => {
      actionContext.dispatch('ACCOUNT_LINK_SUCCESS', { accountType, result });
    })
    .catch((error) => {
      actionContext.dispatch('ERROR', error);
    });
};

export const dismissPasswordDialog = function (actionContext: ActionContext) {
  actionContext.dispatch('DISMISS_PASSWORD_DIALOG');
};

export const delink = function (actionContext: ActionContext, payload: DelinkPayload) {
  const { accountType, onSuccess, ...data } = payload;
  actionContext.dispatch('CURRENT_ACCOUNT_SET', { currentAccount: accountType });
  actionContext.dispatch('LOADING', Object.assign({ action: 'delink' }, payload));
  return thirdPartyAuth
    .delink(accountType, data)
    .then((result) => {
      actionContext.dispatch('ACCOUNT_DELINK_SUCCESS', { accountType, result });
      onSuccess?.();
    })
    .catch((error) => {
      actionContext.dispatch('ERROR', error);
    });
};
